import React, { Fragment, useState } from "react";
import Footer from "../component/Footer";

import { Dialog, Transition, Tab, Disclosure } from "@headlessui/react";
import {
  BsBank2,
  BsBookmarkDashFill,
  BsDownload,
  BsFillCalendarEventFill,
  BsFillGridFill,
  BsTagsFill,
} from "react-icons/bs";
import { FaFileDownload } from "react-icons/fa";
import YoutubeEmbed from "../component/YoutubeEmbed";
import { RxCross1 } from "react-icons/rx";
import {
  boardArray,
  categoryArray,
  paperArray,
  subjectArray,
  yearArray,
} from "../pastPaperArray";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function StudentTools1() {
  let [isOpenPastPaper, setIsOpenPastPaper] = useState(false);
  let [isOpenKnowledge, setIsOpenKnowledge] = useState(false);

  function closeModal() {
    setIsOpenPastPaper(false);
    setIsOpenKnowledge(false);
  }

  function openModalPastPaper() {
    setIsOpenPastPaper(true);
  }
  function openModalKnowledge() {
    setIsOpenKnowledge(true);
  }

  // Dirty Code
  let [categories] = useState({
    IGCSE: [
      {
        Chemistry: [
          {
            CIE: [
              {
                1: [
                  {
                    2022: [
                      {
                        name: "2-12",
                      },
                      {
                        name: "6-12",
                      },
                    ],
                  },
                  {
                    2021: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2021",
                      },
                    ],
                  },
                ],
              },
              {
                2: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
              {
                3: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                4: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                5: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                6: [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
          {
            Edexcel: [
              {
                "1C": [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2022",
                      },
                      {
                        name: "IGCSE_CHEM_CIE_1_2022(1)",
                      },
                    ],
                  },
                  {
                    2021: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2021",
                      },
                    ],
                  },
                ],
              },
              {
                "2C": [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Math: [
          {
            CIE: [
              {
                1: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2022",
                      },
                      {
                        name: "IGCSE_CHEM_CIE_1_2022(1)",
                      },
                    ],
                  },
                  {
                    2021: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2021",
                      },
                    ],
                  },
                ],
              },
              {
                2: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
              {
                3: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                4: [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
          {
            Edexcel: [
              {
                "1F": [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2022",
                      },
                      {
                        name: "IGCSE_CHEM_CIE_1_2022(1)",
                      },
                    ],
                  },
                  {
                    2021: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2021",
                      },
                    ],
                  },
                ],
              },
              {
                "2F": [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
              {
                "3H": [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
              {
                "4H": [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
              {
                "1H": [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
              {
                "2H": [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "Fur Math": [
          {
            Edexcel: [
              {
                1: [
                  {
                    2022: [],
                  },
                ],
                2: [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Economic: [
          {
            CIE: [
              {
                1: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2022",
                      },
                      {
                        name: "IGCSE_CHEM_CIE_1_2022(1)",
                      },
                    ],
                  },
                  {
                    2021: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2021",
                      },
                    ],
                  },
                ],
              },
              {
                2: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
              {
                3: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                4: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                5: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                6: [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
          {
            Edexcel: [
              {
                1: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2022",
                      },
                      {
                        name: "IGCSE_CHEM_CIE_1_2022(1)",
                      },
                    ],
                  },
                  {
                    2021: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2021",
                      },
                    ],
                  },
                ],
              },
              {
                2: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Biology: [
          {
            CIE: [
              {
                1: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2022",
                      },
                      {
                        name: "IGCSE_CHEM_CIE_1_2022(1)",
                      },
                    ],
                  },
                  {
                    2021: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2021",
                      },
                    ],
                  },
                ],
              },
              {
                2: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
              {
                3: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                4: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                5: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                6: [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
          {
            Edexcel: [
              {
                "1B": [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2022",
                      },
                      {
                        name: "IGCSE_CHEM_CIE_1_2022(1)",
                      },
                    ],
                  },
                  {
                    2021: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2021",
                      },
                    ],
                  },
                ],
              },
              {
                "2B": [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Physics: [
          {
            CIE: [
              {
                1: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2022",
                      },
                      {
                        name: "IGCSE_CHEM_CIE_1_2022(1)",
                      },
                    ],
                  },
                  {
                    2021: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2021",
                      },
                    ],
                  },
                ],
              },
              {
                2: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
              {
                3: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                4: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                5: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                6: [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
          {
            Edexcel: [
              {
                "1P": [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2022",
                      },
                      {
                        name: "IGCSE_CHEM_CIE_1_2022(1)",
                      },
                    ],
                  },
                  {
                    2021: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2021",
                      },
                    ],
                  },
                ],
              },
              {
                "2P": [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "ENG-SL": [
          {
            CIE: [
              {
                1: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2022",
                      },
                      {
                        name: "IGCSE_CHEM_CIE_1_2022(1)",
                      },
                    ],
                  },
                  {
                    2021: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2021",
                      },
                    ],
                  },
                ],
              },
              {
                2: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
              {
                3: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                4: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                5: [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    "A-LEVEL": [
      {
        Biology: [
          {
            CIE: [
              {
                1: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2022",
                      },
                      {
                        name: "IGCSE_CHEM_CIE_1_2022(1)",
                      },
                    ],
                  },
                  {
                    2021: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2021",
                      },
                    ],
                  },
                ],
              },
              {
                2: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
              {
                3: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                4: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                5: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                6: [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.2": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.3": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.4": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.5": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.6": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Chemistry: [
          {
            CIE: [
              {
                1: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2022",
                      },
                      {
                        name: "IGCSE_CHEM_CIE_1_2022(1)",
                      },
                    ],
                  },
                  {
                    2021: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2021",
                      },
                    ],
                  },
                ],
              },
              {
                2: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
              {
                3: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                4: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                5: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                6: [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.2": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.3": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.4": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.5": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.6": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Physics: [
          {
            CIE: [
              {
                1: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2022",
                      },
                      {
                        name: "IGCSE_CHEM_CIE_1_2022(1)",
                      },
                    ],
                  },
                  {
                    2021: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2021",
                      },
                    ],
                  },
                ],
              },
              {
                2: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
              {
                3: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                4: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                5: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                6: [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.2": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.3": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.4": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.5": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.6": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Math: [
          {
            CIE: [
              {
                1: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2022",
                      },
                      {
                        name: "IGCSE_CHEM_CIE_1_2022(1)",
                      },
                    ],
                  },
                  {
                    2021: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2021",
                      },
                    ],
                  },
                ],
              },
              {
                2: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
              {
                3: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                4: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                5: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                6: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                7: [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Economic: [
          {
            CIE: [
              {
                1: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2022",
                      },
                      {
                        name: "IGCSE_CHEM_CIE_1_2022(1)",
                      },
                    ],
                  },
                  {
                    2021: [
                      {
                        name: "IGCSE_CHEM_CIE_1_2021",
                      },
                    ],
                  },
                ],
              },
              {
                2: [
                  {
                    2022: [
                      {
                        name: "IGCSE_CHEM_CIE_2_2022",
                      },
                    ],
                  },
                ],
              },
              {
                3: [
                  {
                    2022: [],
                  },
                ],
              },
              {
                4: [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.2": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.3": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.4": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    IAL: [
      {
        Biology: [
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.2": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.3": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.4": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.5": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.6": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Chemistry: [
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.2": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.3": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.4": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.5": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.6": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Physics: [
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.2": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.3": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.4": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.5": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.6": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.7": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Math: [
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Economic: [
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.2": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.3": [
                  {
                    2022: [],
                  },
                ],
              },
              {
                "U.4": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    IB: [
      {
        Biology: [
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Chemistry: [
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Physics: [
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Math: [
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Economic: [
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    AP: [
      {
        Biology: [
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Chemistry: [
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Physics: [
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Math: [
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Economic: [
          {
            Edexcel: [
              {
                "U.1": [
                  {
                    2022: [],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  });

  return (
    <div>
      <div className="bg-white py-24 sm:py-32">
        <div className="mx-auto max-w-screen-2xl px-6 lg:px-8">
          <div className="mx-auto max-w-7xl">
            <h2 className=" my-5 mx-auto max-w-max rounded-full bg-slate-100 px-5 py-1 text-center text-2xl font-extrabold  text-purple-500">
              Student Tools
            </h2>
            <p className=" mx-auto max-w-5xl text-center text-6xl font-extrabold   leading-tight tracking-tight text-gray-800 sm:text-7xl lg:max-w-3xl 2xl:max-w-5xl 2xl:text-9xl">
              <span className="text-purple-500">เครื่องมือช่วยเรียน</span>
              สำหรับน้อง ๆ
            </p>
          </div>
          <div className="my-12 grid sm:grid-cols-2 sm:gap-8 xl:grid-cols-2 ">
            <div
              className="cursor-pointer  rounded-3xl bg-slate-100 p-10 text-center text-gray-800 duration-200 ease-in hover:scale-105  "
              onClick={openModalPastPaper}
            >
              <img src="./img/docs.png" className="mx-auto mb-8" alt="" />
              <p className=" inline rounded-full  bg-white px-3">Past Paper</p>
              <h3 className="mt-2 text-4xl font-bold">ข้อสอบเก่า</h3>
            </div>
            <div
              className="mx-auto mt-10 w-full cursor-pointer rounded-3xl bg-slate-100 p-10 text-center text-gray-800 duration-200 ease-in hover:scale-105 sm:mt-0 "
              onClick={openModalKnowledge}
            >
              <img src="./img/clip.png" className="mx-auto mb-8" alt="" />
              <p className=" inline rounded-full  bg-white px-3">Knowledge</p>
              <h3 className="mt-2 text-4xl font-bold">คลิปความรู้</h3>
            </div>
          </div>
        </div>
      </div>

      <Transition appear show={isOpenPastPaper} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 mt-20 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-screen-xl transform rounded-2xl bg-white p-3 text-left align-middle transition-all  sm:p-6">
                  <a
                    className="absolute -right-3 -top-3 z-10 cursor-pointer rounded-full bg-white p-2 text-2xl text-gray-800 shadow-lg"
                    onClick={closeModal}
                  >
                    <RxCross1 />
                  </a>

                  <div className=" lg:px-10 ">
                    <div className="grid sm:grid-cols-6">
                      <div className="hidden sm:block">
                        <h1 className="mb-1 py-3 text-xl ">
                          <BsBank2 className=" hidden text-2xl text-gray-800 xl:inline" />
                          &nbsp; Exam
                        </h1>
                        <h1 className="mb-1 py-3 text-xl ">
                          <BsBookmarkDashFill className=" hidden  text-2xl text-gray-800 xl:inline" />
                          &nbsp; Subject
                        </h1>
                        <h1 className="mb-1 py-3 text-xl ">
                          <BsTagsFill className=" hidden  text-2xl text-gray-800 xl:inline" />
                          &nbsp; Board
                        </h1>
                        <h1 className="mb-1 py-3 text-xl ">
                          <BsFillGridFill className="   hidden text-2xl text-gray-800 xl:inline" />
                          &nbsp; Paper / Unit
                        </h1>
                        <h1 className="mb-1 py-3 text-xl ">
                          <BsFillCalendarEventFill className=" hidden  text-2xl text-gray-800 xl:inline" />
                          &nbsp; Year
                        </h1>
                      </div>
                      <div className="col-span-5">
                        <Tab.Group>
                          <h1 className="py-3 text-xl font-bold sm:hidden">
                            {/* <BsBank2 className=" inline text-2xl " /> */}
                            &nbsp; Exam
                          </h1>
                          <Tab.List className="flex space-x-1  rounded-xl bg-blue-900/20 p-1">
                            {Object.keys(categories).map((category) => (
                              <Tab
                                key={category}
                                className={({ selected }) =>
                                  classNames(
                                    "w-full rounded-lg py-2.5 text-sm font-bold leading-5 text-blue-700",
                                    "ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2",
                                    selected
                                      ? "bg-white shadow"
                                      : "text-slate-400 hover:bg-white/[0.12] hover:text-white"
                                  )
                                }
                              >
                                {category}
                              </Tab>
                            ))}
                          </Tab.List>
                          <Tab.Panels className="mt-2">
                            {/* Subjects */}
                            {Object.values(categories).map((subjects, idx1) => (
                              <Tab.Panel key={idx1}>
                                <Tab.Group>
                                  <h1 className="py-3 text-xl font-bold sm:hidden">
                                    {/* <BsBank2 className=" inline text-2xl " /> */}
                                    &nbsp; Subject
                                  </h1>
                                  <Tab.List className="flex space-x-1  rounded-xl bg-blue-900/20 p-1">
                                    {subjects.map((subject) => (
                                      <>
                                        {Object.keys(subject).map((subject) => {
                                          return (
                                            <Tab
                                              key={subject}
                                              className={({ selected }) =>
                                                classNames(
                                                  "w-full rounded-lg py-2.5 text-xs font-bold leading-5 text-blue-700 sm:text-sm",
                                                  "ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2",
                                                  selected
                                                    ? "bg-white shadow"
                                                    : "text-slate-400 hover:bg-white/[0.12] hover:text-white"
                                                )
                                              }
                                            >
                                              {subject}
                                            </Tab>
                                          );
                                        })}
                                      </>
                                    ))}
                                  </Tab.List>
                                  <Tab.Panels className="mt-2">
                                    {/* Board */}

                                    {subjects.map((subject, idx2) => (
                                      <>
                                        {Object.values(subject).map(
                                          (boards, idx) => (
                                            <Tab.Panel key={idx}>
                                              <Tab.Group>
                                                <h1 className="py-3 text-xl font-bold sm:hidden">
                                                  {/* <BsBank2 className=" inline text-2xl " /> */}
                                                  &nbsp; Board
                                                </h1>
                                                <Tab.List className="flex space-x-1  rounded-xl bg-blue-900/20 p-1">
                                                  {boards.map((board) => (
                                                    <>
                                                      {Object.keys(board).map(
                                                        (board) => (
                                                          <Tab
                                                            key={board}
                                                            className={({
                                                              selected,
                                                            }) =>
                                                              classNames(
                                                                "w-full rounded-lg py-2.5 text-sm font-bold leading-5 text-blue-700",
                                                                "ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2",
                                                                selected
                                                                  ? "bg-white shadow"
                                                                  : "text-slate-400 hover:bg-white/[0.12] hover:text-white"
                                                              )
                                                            }
                                                          >
                                                            {board}
                                                          </Tab>
                                                        )
                                                      )}
                                                    </>
                                                  ))}
                                                </Tab.List>
                                                <Tab.Panels className="mt-2">
                                                  {/* Paper / Unit */}

                                                  {boards.map((board, idx3) => (
                                                    <>
                                                      {Object.values(board).map(
                                                        (board, idx) => (
                                                          <Tab.Panel key={idx}>
                                                            <Tab.Group>
                                                              <h1 className="py-3 text-xl font-bold sm:hidden">
                                                                {/* <BsBank2 className=" inline text-2xl " /> */}
                                                                &nbsp; Paper /
                                                                Unit
                                                              </h1>
                                                              <Tab.List className="flex space-x-1  rounded-xl bg-blue-900/20 p-1">
                                                                {board.map(
                                                                  (board) => (
                                                                    <>
                                                                      {Object.keys(
                                                                        board
                                                                      ).map(
                                                                        (
                                                                          papers
                                                                        ) => (
                                                                          <Tab
                                                                            key={
                                                                              papers
                                                                            }
                                                                            className={({
                                                                              selected,
                                                                            }) =>
                                                                              classNames(
                                                                                "w-full rounded-lg py-2.5 text-sm font-bold leading-5 text-blue-700",
                                                                                "ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2",
                                                                                selected
                                                                                  ? "bg-white shadow"
                                                                                  : "text-slate-400 hover:bg-white/[0.12] hover:text-white"
                                                                              )
                                                                            }
                                                                          >
                                                                            {
                                                                              papers
                                                                            }
                                                                          </Tab>
                                                                        )
                                                                      )}
                                                                    </>
                                                                  )
                                                                )}
                                                              </Tab.List>
                                                              <Tab.Panels className="mt-2">
                                                                {/* Year */}

                                                                {board.map(
                                                                  (
                                                                    board,
                                                                    idx4
                                                                  ) => (
                                                                    <>
                                                                      {Object.values(
                                                                        board
                                                                      ).map(
                                                                        (
                                                                          years,
                                                                          idx
                                                                        ) => (
                                                                          <Tab.Panel
                                                                            key={
                                                                              idx
                                                                            }
                                                                          >
                                                                            <Tab.Group>
                                                                              <h1 className="py-3 text-xl font-bold sm:hidden">
                                                                                {/* <BsBank2 className=" inline text-2xl " /> */}
                                                                                &nbsp;
                                                                                Year
                                                                              </h1>
                                                                              <Tab.List className="flex space-x-1  rounded-xl bg-blue-900/20 p-1">
                                                                                {years.map(
                                                                                  (
                                                                                    year
                                                                                  ) => (
                                                                                    <>
                                                                                      {Object.keys(
                                                                                        year
                                                                                      ).map(
                                                                                        (
                                                                                          year
                                                                                        ) => (
                                                                                          <Tab
                                                                                            key={
                                                                                              year
                                                                                            }
                                                                                            className={({
                                                                                              selected,
                                                                                            }) =>
                                                                                              classNames(
                                                                                                "w-full rounded-lg py-2.5 text-sm font-bold leading-5 text-blue-700",
                                                                                                "ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2",
                                                                                                selected
                                                                                                  ? "bg-white shadow"
                                                                                                  : "text-slate-400 hover:bg-white/[0.12] hover:text-white"
                                                                                              )
                                                                                            }
                                                                                          >
                                                                                            {
                                                                                              year
                                                                                            }
                                                                                          </Tab>
                                                                                        )
                                                                                      )}
                                                                                    </>
                                                                                  )
                                                                                )}
                                                                              </Tab.List>
                                                                              <Tab.Panels className="mt-2">
                                                                                {/* Result */}

                                                                                {years.map(
                                                                                  (
                                                                                    year,
                                                                                    idx5
                                                                                  ) => (
                                                                                    <>
                                                                                      {Object.values(
                                                                                        year
                                                                                      ).map(
                                                                                        (
                                                                                          items,
                                                                                          idx
                                                                                        ) => (
                                                                                          <Tab.Panel
                                                                                            key={
                                                                                              idx
                                                                                            }
                                                                                          >
                                                                                            {/* {`${categoryArray[idx1]}/${subjectArray[idx1][idx2]}/${boardArray[idx1][idx2][idx3]}/${paperArray[idx1][idx2][idx3][idx4]}/${yearArray[idx5]}`} */}
                                                                                            {items.map(
                                                                                              (
                                                                                                item
                                                                                              ) => (
                                                                                                <>
                                                                                                  <div className="m-2 inline-block rounded-lg border border-slate-300 p-4">
                                                                                                    <span className="font-bold">
                                                                                                      Question{" "}
                                                                                                    </span>
                                                                                                    {
                                                                                                      item.name
                                                                                                    }
                                                                                                    <a
                                                                                                      className="ml-4"
                                                                                                      href={`./paper/${categoryArray[idx1]}/${subjectArray[idx1][idx2]}/${boardArray[idx1][idx2][idx3]}/${paperArray[idx1][idx2][idx3][idx4]}/${yearArray[idx5]}/qp/${yearArray[idx5]}-${item.name}-QP.pdf`}
                                                                                                      target="_blank"
                                                                                                    >
                                                                                                      <FaFileDownload className="inline text-2xl font-bold text-purple-500" />
                                                                                                    </a>
                                                                                                    <hr className="my-3" />
                                                                                                    <span className="font-bold">
                                                                                                      Mark
                                                                                                      Scheme{" "}
                                                                                                    </span>
                                                                                                    {
                                                                                                      item.name
                                                                                                    }
                                                                                                    <a
                                                                                                      className="ml-4"
                                                                                                      href={`./paper/${categoryArray[idx1]}/${subjectArray[idx1][idx2]}/${boardArray[idx1][idx2][idx3]}/${paperArray[idx1][idx2][idx3][idx4]}/${yearArray[idx5]}/ms/${yearArray[idx5]}-${item.name}-MS.pdf`}
                                                                                                      target="_blank"
                                                                                                    >
                                                                                                      <FaFileDownload className="inline text-2xl font-bold text-purple-500" />
                                                                                                    </a>
                                                                                                  </div>
                                                                                                </>
                                                                                              )
                                                                                            )}
                                                                                          </Tab.Panel>
                                                                                        )
                                                                                      )}
                                                                                    </>
                                                                                  )
                                                                                )}
                                                                              </Tab.Panels>
                                                                            </Tab.Group>
                                                                          </Tab.Panel>
                                                                        )
                                                                      )}
                                                                    </>
                                                                  )
                                                                )}
                                                              </Tab.Panels>
                                                            </Tab.Group>
                                                          </Tab.Panel>
                                                        )
                                                      )}
                                                    </>
                                                  ))}
                                                </Tab.Panels>
                                              </Tab.Group>
                                            </Tab.Panel>
                                          )
                                        )}
                                      </>
                                    ))}
                                  </Tab.Panels>
                                </Tab.Group>
                              </Tab.Panel>
                            ))}
                          </Tab.Panels>
                        </Tab.Group>
                      </div>
                    </div>
                    {/* Categories */}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      <Transition appear show={isOpenKnowledge} as={Fragment}>
        <Dialog as="div" className="relative z-10 " onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 mt-20 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out   duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-screen-xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle transition-all sm:p-10">
                  <a
                    className="absolute right-7 top-7 z-10 cursor-pointer rounded-full bg-white p-2 text-2xl text-gray-800 shadow-lg"
                    onClick={closeModal}
                  >
                    <RxCross1 />
                  </a>

                  <div className="mb-20">
                    <h1 className="text-4xl font-bold">
                      <span style={{ color: "#a555ec" }}>IGCSE</span> CHEMISTRY
                    </h1>
                    <hr className="my-5" />
                    <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 2xl:grid-cols-3">
                      <YoutubeEmbed embedId="zorzzRgr5ic" />
                      <YoutubeEmbed embedId="W23z7_ervlk" />
                      <YoutubeEmbed embedId="hZhIEF-1h6A" />
                      <YoutubeEmbed embedId="TCi2Kk83DSU" />
                      <YoutubeEmbed embedId="I3CyhJmkpOY" />
                      <YoutubeEmbed embedId="HYBGr0jGuxI" />
                    </div>
                  </div>

                  <div className="mb-20">
                    <h1 className="text-4xl font-bold">
                      <span style={{ color: "#a555ec" }}>IGCSE</span> PHYSICS
                    </h1>
                    <hr className="my-5" />
                    <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 2xl:grid-cols-3">
                      <YoutubeEmbed embedId="VPtMraYr3Ds" />
                      <YoutubeEmbed embedId="nfpxHciRHik" />
                      <YoutubeEmbed embedId="RDPqIMHUVgw" />
                      <YoutubeEmbed embedId="vI8L2LdHhIU" />
                    </div>
                  </div>

                  <div className="mb-20">
                    <h1 className="text-4xl font-bold">
                      <span style={{ color: "#a555ec" }}>A-LEVEL</span> MATH
                    </h1>
                    <hr className="my-5" />
                    <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 2xl:grid-cols-3">
                      <YoutubeEmbed embedId="6IinbhGIKEs" />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      <Footer />
    </div>
  );
}
